import { render, staticRenderFns } from "./Lens.vue?vue&type=template&id=5b9e8768&scoped=true&"
import script from "./Lens.vue?vue&type=script&lang=js&"
export * from "./Lens.vue?vue&type=script&lang=js&"
import style0 from "./Lens.vue?vue&type=style&index=0&id=5b9e8768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e8768",
  null
  
)

export default component.exports